export default {
  path: "/bbdb",
  name: "bbdb",
  component: () => import("./index"),
  redirect: "/bbdb/index",
  children: [
    {
      path: "index",
      name: "首页",
      meta: {
          
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./indexFrom")
    },
    {
      path: "bbdbDetail",
      name: "详情",
      meta: {
        breadNumber: 3,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./bbdbDetail")
    },
    {
      path: "list",
      name: "列表",
      meta: {
        breadNumber: 2,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./list")
    },
    {
      path: "evaluate",
      name: "评价",
      meta: {
        breadNumber: 5,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./evaluate")
    },
    {
      path: "evaluateDetail",
      name: "评价详情",
      meta: {
        breadNumber: 4,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./evaluateDetail")
    },
    {
      path: "feedback",
      name: "案件回复",
      meta: {
        breadNumber: 4,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./feedback")
    },
    {
      path: "anew",
      name: "重新提交",
      meta: {
        breadNumber: 4,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./anew")
    },
    {
      path: "bohui",
      name: "我有疑议",
      meta: {
        breadNumber: 4,
        image: require("../../assets/image/bbdbtb.png")
      },
      component: () => import("./bohui")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/views/bbdb/router.js